import { createAction } from 'redux-act';

/**
 * Create action
 */

const filterLevelChange = createAction('FILTER_LEVEL_CHANGE');
const filterTypeChange = createAction('FILTER_TYPE_CHANGE');
const filterNameChange = createAction('FILTER_NAME_CHANGE');
const filterSortChange = createAction('FILTER_Sort_CHANGE');
const filterMinTimeChange = createAction('FILTER_MIN_TIME_CHANGE');
const filterMaxTimeChange = createAction('FILTER_MAX_TIME_CHANGE');
const filterLoadExisting = createAction('FILTER_LOAD_EXISTING');

export function loadExisting(filters) {
    return filterLoadExisting({
        filters
    });
}

export function levelChange(levels) {
    return filterLevelChange({
        levels
    });
}

export function typeChange(types) {
    return filterTypeChange({
        types
    });
}

export function nameChange(name) {
    return filterNameChange({
        name
    });
}

export function sortChange(name) {
    return filterSortChange({
        name
    });
}

export function minTimeChange(time) {
    return filterMinTimeChange({
        time
    });
}

export function maxTimeChange(time) {
    return filterMaxTimeChange({
        time
    });
}

export {
    filterTypeChange,
    filterLevelChange,
    filterNameChange,
    filterMinTimeChange,
    filterMaxTimeChange,
    filterSortChange,
    filterLoadExisting
}
